import { AuthSDK } from './fns/auth';
import { CRSAuthSDK } from './fns/creditScore';
import './yup';

AuthSDK.inititateAPI(
  `${new URL('./auth/', process.env.REACT_APP_API_URL).href}` ?? ''
);
CRSAuthSDK.inititateAPI(
  `${new URL('./', process.env.REACT_APP_API_URL).href}` ?? ''
);
